import { Icon, Modal, Text } from 'components'

import styles from './styles.module.scss'
import { useRef } from 'react'

interface ChangePaymentProps {
  onConfirm: () => void
}

const ChangePayment = ({ onConfirm }: ChangePaymentProps) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null)

  return (
    <Modal.Content className={styles.container}>
      <div className={styles.content}>
        <Icon width={48} color="element-default" name="warning" />

        <Modal.Title className={styles.title}>
          Adicionar nova forma de pagamento?
        </Modal.Title>

        <Text as="p" weight="regular">
          Caso já exista uma forma de pagamento cadastrada, ela será removida.
        </Text>
      </div>

      <Modal.Footer className={styles.footer}>
        <div className={styles.actions}>
          <Modal.Close asChild>
            <button ref={closeButtonRef}>Cancelar</button>
          </Modal.Close>
          <button
            onClick={() => {
              onConfirm()
              closeButtonRef?.current?.click()
            }}
          >
            Confirmar
          </button>
        </div>
      </Modal.Footer>
    </Modal.Content>
  )
}

export default ChangePayment
